import { makeApiRequest } from '@/src/lib/api-request'
import { useMutation } from '@tanstack/react-query'
import { useUser } from '@/src/store/user-store'
import { encryptPassword } from '@/src/lib/utils'

export const useSendOtpVerifyPhone = () => {
  return useMutation({
    mutationKey: ['user', 'send-otp-phone'],
    mutationFn: async (data: {
      phoneNumber: string
      countryCode: string
      cfToken?: string
    }) => {
      const challengeToken =
        data.cfToken || localStorage.getItem('cft-otpGenerateforPhone') || ''

      await makeApiRequest({
        method: 'POST',
        url: '/User/otpGenerateforPhone',
        data: {
          newphoneNumber: data.phoneNumber,
          countryCode: data.countryCode,
        },
        isAuthenticated: true,
        fallbackError: 'Error while sending verification code',
        headers: {
          'x-api-chlng': challengeToken
        },
        isV3Api:true
      })
    },
  })
}

export const useSendDeactivationOtpMutation = () => {
  return useMutation({
    mutationKey: ['user', 'send-otp-deactivate'],
    mutationFn: async (params?: { cfToken?: string }) => {
      const challengeToken =
        params?.cfToken ||
        localStorage.getItem('cft-otpGenerateforDeactivate') ||
        ''

      const response = await makeApiRequest({
        method: 'GET',
        url: '/User/otpGenerateforDeactivate',
        data: {},
        isAuthenticated: true,
        fallbackError: 'Error while sending verification code',
        headers: {
          'x-api-chlng': challengeToken
        },
        isV3Api:true
      })
    },
  })
}

export const useValidateDeactivationOtpMutation = () => {
  return useMutation({
    mutationKey: ['user', 'verify-otp-deactivate'],
    mutationFn: async (otp: string) => {
      const response = await makeApiRequest({
        method: 'POST',
        url: '/User/deactOtpVerify',
        data: {
          otp,
        },
        isAuthenticated: true,
        fallbackError: 'Error while verifying verification code',
        isV3Api:true
      })

      return response.token as string
    },
  })
}

interface DeactivateUserDto {
  refresh_token: string
  token: string
  password: string
  reason: string
  more_details: string
}

export const useDeactivateUserMutation = () => {
  const { refreshToken } = useUser()

  return useMutation({
    mutationKey: ['user', 'verify-otp-deactivate'],
    mutationFn: async ({
      password,
      reason,
      more_details,
      token,
    }: {
      password: string
      reason: string
      more_details: string
      token: string
    }) => {
      const dataProps: DeactivateUserDto = {
        refresh_token: refreshToken || '',
        token,
        password:encryptPassword(password),
        reason,
        more_details,
      }
      const response = await makeApiRequest({
        method: 'POST',
        url: '/User/deactivate',
        data: dataProps,
        isAuthenticated: true,
        fallbackError: 'Error while deactivating user',
        isV3Api:true
      })
      console.log('deactivate user response', response)
      return response?.response
    },
  })
}

export const useSendDeletionOtpMutation = () => {
  return useMutation({
    mutationKey: ['user', 'send-otp-deactivate'],
    mutationFn: async (params?: { cfToken?: string }) => {
      const challengeToken =
        params?.cfToken || localStorage.getItem('cft-otpGenerateforDelete') || ''

      const response = await makeApiRequest({
        method: 'GET',
        url: '/User/otpGenerateforDelete',
        data: {},
        isAuthenticated: true,
        fallbackError: 'Error while sending verification code',
        headers: {
          'x-api-chlng': challengeToken
        },
        isV3Api:true
      })

      console.log(response)
    },
  })
}

export const useValidateDeletionOtpMutation = () => {
  return useMutation({
    mutationKey: ['user', 'verify-otp-deactivate'],
    mutationFn: async (otp: string) => {
      const response = await makeApiRequest({
        method: 'POST',
        url: '/User/deleteOtpVerify',
        data: {
          otp,
        },
        isAuthenticated: true,
        fallbackError: 'Error while verifying verification code',
        isV3Api:true
      })

      return response.token as string
    },
  })
}

interface DeleteUserDto {
  refresh_token: string
  token: string
  password: string
  reason: string
  more_details: string
}

export const useDeleteUserMutation = () => {
  const { refreshToken } = useUser()

  return useMutation({
    mutationKey: ['user', 'verify-otp-deactivate'],
    mutationFn: async ({
      password,
      reason,
      more_details,
      token,
    }: {
      password: string
      reason: string
      more_details: string
      token: string
    }) => {
      const dataProps: DeleteUserDto = {
        refresh_token: refreshToken || '',
        token,
       password: encryptPassword(password),
        reason,
        more_details,
      }
      const response = await makeApiRequest({
        method: 'POST',
        url: '/User/accountDelete',
        data: dataProps,
        isAuthenticated: true,
        fallbackError: 'Error while deactivating user',
        isV3Api:true
      })
      return response?.response
    },
  })
}

export type LoginUserMutationParams = {
  email: string
  password: string
  type: 'normal' | 'business'
}
